<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" @close="closeModal()" class="relative z-[44444444444444]">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-6xl min-h-[70vh] transform overflow-hidden bg-white md:px-20 py-6 px-4 text-left align-middle shadow-xl shadow-slate-800 transition-all"
            >
              <div
                class="flex justify-center items-center absolute right-5 top-5"
              >
                <button
                  @click="closeModal()"
                  class="bg-[#D8D8D8] w-8 h-8 flex justify-center items-center rounded-full"
                >
                  <XIcon class="w-6 h-6 text-secondary" />
                </button>
              </div>
              <CommonHowItWorks :in-model="true" title-position="left" />
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/vue";
import { XIcon } from "@heroicons/vue/solid";
const props = defineProps({
  isOpen: Boolean,
});

const emit = defineEmits(["onModalClose"]);
const closeModal = () => {
  emit("onModalClose");
};
</script>
